module.exports = __webpack_public_path__ + "static/img/7.931c119.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/zh/7.png
// module id = YQhx
// module chunks = 0